<div class="page-container">
  <div class="header-row">
    <h1>Customers</h1>
    <app-table-header-actions (exportEvent)="export()"></app-table-header-actions>
  </div>

  <div class="table-container">
    <app-table #customersTable class="customer-table" [construct]="construct"></app-table>
  </div>
</div>

